

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _constants = require('./constants');

var getCurrencyCode = function getCurrencyCode(currencyCode) {
    if (currencyCode === undefined) {
        return 'USD';
    }
    return currencyCode;
};

var moneyJson = function moneyJson(currencyCode, value) {
    return {
        currency_code: getCurrencyCode(currencyCode),
        value: formatValue(value, 2)
    };
};

var formatValue = function formatValue(amount, digits) {
    if (amount !== undefined) {
        return (+amount).toFixed(digits);
    }
    return amount;
};

var previousPageUrl = function previousPageUrl() {
    _logger.$logger.info('Raw Previous page URLs', {
        documentReferrer: document.referrer,
        metaReferer: _squid.$meta.referer
    });
    var documentReferrer = nullIfHostIsPaypal(document.referrer, 'document.referrer');
    var metaReferer = nullIfHostIsPaypal(_squid.$meta.referer, '$meta.referer');
    _logger.$logger.info('Previous page URLs', {
        documentReferrer: documentReferrer,
        metaReferer: metaReferer
    });
    return documentReferrer || metaReferer;
};

var nullIfHostIsPaypal = function nullIfHostIsPaypal(urlString, source) {
    if (!urlString) {
        return null;
    }
    try {
        var anchorElement = document.createElement('a');
        anchorElement.href = urlString;
        var hostname = anchorElement.hostname;
        if (hostname.indexOf(_squid.$meta.domain) >= 0) {
            _logger.$logger.info('Previous URL contains ' + _squid.$meta.domain, {
                source: source
            });
            return null;
        }
        return urlString;
    } catch (err) {
        _logger.$logger.warn('Previous URL Process Error', {
            name: err && err.name,
            message: err && err.message
        });
        return null;
    }
};

var sanitizeXclickParams = function sanitizeXclickParams(xclickParams) {
    try {
        if (!xclickParams) {
            return;
        }
        var sanitizedXclickParams = JSON.parse(JSON.stringify(xclickParams));
        for (var key in sanitizedXclickParams) {
            if (sanitizedXclickParams.hasOwnProperty(key) && _constants.PII_XCLICK_PARAMS.indexOf(key) > -1) {
                sanitizedXclickParams[key] = _constants.MASKED_LOG;
            }
        }
        return sanitizedXclickParams;
    } catch (err) {
        return 'Error in logging: ' + (err && err.name);
    }
};

module.exports = {
    getCurrencyCode: getCurrencyCode,
    moneyJson: moneyJson,
    formatValue: formatValue,
    previousPageUrl: previousPageUrl,
    sanitizeXclickParams: sanitizeXclickParams
};

_logger.$logger;

_squid.$meta;

_constants.PII_XCLICK_PARAMS;

_constants.MASKED_LOG;


//////////////////
// WEBPACK FOOTER
// ./js/lib/util.js
// module id = ./js/lib/util.js
// module chunks = 0